/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"legal-disclaimers-page": require("./legal-disclaimers-page.json"),
};
